import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";

export const sendEmailReporte = async(objeto) =>{
    const result = await PrivateInterceptor('email/reporte', 'POST', objeto)
}

export const sendCorreoCajaChica = async(IdComprobante) =>{
    const result = await PrivateInterceptor(`email/CajaChica`, 'POST', {IdComprobante: IdComprobante});
    return result
}

export const sendEmailClientes = async(objeto) =>{
    const result = await PrivateInterceptor('email/DiasVencidosClientes', 'POST', objeto)
    return result
}

export const getCorreos = async (IdListaCorreo) => {
    const result = await PrivateInterceptor(`email/${IdListaCorreo}`)
    return result
 }

export const getCorreosCliente = async(Token) => {
    const result = await PublicInterceptor('email/listaCorreo/token', 'GET', {}, Token)
    return result;
}

export const sendEmailInscripcion = async(objeto, Token) =>{
    const result = await PublicInterceptor('email/Clientes/token', 'POST', objeto, Token)
    return result
}

export const sendEmailInscripcionCliente = async(objeto) =>{
    const result = await PrivateInterceptor('email/Clientes', 'POST', objeto)
    return result
}
